export const DOCSEARCH_KEY = '03ed91882fa135da9511824de27adb23';
